var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDepNumberIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.172 6.5L17 8.328v3.344L15.172 13.5H4.828L3 11.672V8.328L4.828 6.5h10.344zM3 4.5H1v11h18v-11H3zM10 8l-2 2 2 2 2-2-2-2z",
    fill: "#9A9CAC"
  })));
}

export default SvgDepNumberIcon;